class StyleCache {
    constructor() {
        this.cache = new Map();
    }

    get(key) {
        return this.cache.get(key);
    }

    set(key, value) {
        this.cache.set(key, value)
    }

    has(key) {
        return this.cache.has(key)
    }

    delete(key) {
        this.cache.delete(key)
    }

    clear() {
        this.cache.clear()
    }
}

export default StyleCache;
